export default __webpack_public_path__ + "static/media/note_copy.52e41988.svg";